<template>
  <card-edit @edit="$emit('edit')">
    <v-card-title class="py-2 font-weight-black">
      {{ $t('delivery.product.products') }}
    </v-card-title>

    <v-card-text class="px-1 my-0 px-md-12">
      <template v-if="order.promos.length > 0">
        <v-list class="px-2 pt-0" dense>
          <v-list-item>
            <v-list-item-title class="font-weight-bold title">
              Promos
            </v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <template v-for="orderPromo in order.promos">
            <div :key="orderPromo.id">
              <customer-cart-detail-promo
                  :order-promo="orderPromo"
                  :show-remove-button="false"
              ></customer-cart-detail-promo>
              <v-divider class="my-2"></v-divider>
            </div>
          </template>
        </v-list>
      </template>

      <order-items :items="order.items"></order-items>
    </v-card-text>
    <v-divider></v-divider>
  </card-edit>

</template>

<script>
import OrderItems from "@/modules/delivery/components-core/shared/OrderItems/OrderItems.vue";
import CardEdit from "@/modules/delivery/components/CardEdit/CardEdit.vue";
import CustomerCartDetailPromo
  from "@/modules/delivery/components-core/customer/CustomerCartDetail/CustomerCartDetailPromo.vue";

export default {
  name: "OrderReviewItems",
  components: {CustomerCartDetailPromo, OrderItems, CardEdit},
  data() {
    return {
      hover: false,
    }
  },
  computed:{
    order() {
      return this.$store.getters.orderSystem.order;
    }
  }
}
</script>

<style scoped>

</style>
